import axios from 'axios'

export const getIdAndContentTypeFromTopics = (topics: any) =>
  topics.map((topic: {contentType: string, id: string}) =>
    ({ contentType: topic.contentType, id: parseInt(topic.id) }))

export const performBulkActionForTopics = async (topics: any, action: string) => {
  const selectedTopics = getIdAndContentTypeFromTopics(topics
  )
  await axios.post(`/community/api/bulk/process?moderatorId=${window.inSidedData.user.userid}`, {
    'action': action,
    'topics': selectedTopics
  })
}
